const NAMESPACE = 'App'

// socket
export const SUBSCRIBE_VERSION = NAMESPACE + '/SubscribeVersion'
export const VERSION_UPDATED = NAMESPACE + '/VersionUpdated'


// WEBPACK FOOTER //
// ./lib/app/protocol.js